import React from "react";
import { ErrorBoundary } from "./components";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { routes } from "./utils/routes";
import { AnimatePresence } from "framer-motion";
import { Loader } from "./assets/icons";

const LandingPage = React.lazy(() =>
  import("./pages").then(({ LandingPage }) => ({ default: LandingPage }))
);
const SearchPage = React.lazy(() =>
  import("./pages").then(({ SearchPage }) => ({ default: SearchPage }))
);

function App() {
  return (
    <React.Suspense
      fallback={
        <div className="absolute top-[40vh] left-[45vw]">
          <img src={Loader} alt="loader" className="" />
        </div>
      }
    >
      <AnimatePresence mode="wait">
        <ErrorBoundary>
          <BrowserRouter>
            <Routes>
              <Route path={routes.landing} element={<LandingPage />} />
              <Route path={routes.search} element={<SearchPage />} />
            </Routes>
          </BrowserRouter>
        </ErrorBoundary>
      </AnimatePresence>
    </React.Suspense>
  );
}

export default App;
